import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "GoDesign"
});
const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M2.84119 2.57495C2.84119 1.81556 3.45679 1.19995 4.21619 1.19995H15.7662C16.5256 1.19995 17.1412 1.81556 17.1412 2.57495V10.0396V17.425C17.1412 18.1843 16.5256 18.8 15.7662 18.8H10.5406H4.21619C3.45679 18.8 2.84119 18.1843 2.84119 17.425V2.57495ZM15.5023 14.55C15.5023 15.0816 15.0714 15.5125 14.5398 15.5125H5.44202C4.91045 15.5125 4.47952 15.0816 4.47952 14.55C4.47952 14.0185 4.91045 13.5875 5.44202 13.5875H14.5398C15.0714 13.5875 15.5023 14.0185 15.5023 14.55ZM14.5397 10.4646C15.0713 10.4646 15.5022 10.0337 15.5022 9.50213C15.5022 8.97056 15.0713 8.53963 14.5397 8.53963H10.7541C10.2225 8.53963 9.79159 8.97056 9.79159 9.50213C9.79159 10.0337 10.2225 10.4646 10.7541 10.4646H14.5397ZM15.5023 5.32334C15.5023 5.85491 15.0714 6.28584 14.5398 6.28584H12.1304C11.5988 6.28584 11.1679 5.85491 11.1679 5.32334C11.1679 4.79176 11.5988 4.36084 12.1304 4.36084H14.5398C15.0714 4.36084 15.5023 4.79176 15.5023 5.32334ZM7.03757 8.62327C6.60473 8.37198 6.10335 8.35144 5.67171 8.52058L8.87115 4.03359C9.01904 3.83425 9.30279 3.7823 9.52883 3.91398C9.74405 4.03842 9.84385 4.29213 9.76569 4.51563L7.78904 9.65622C7.69646 9.237 7.43675 8.85523 7.03757 8.62327ZM4.69299 9.52818C4.25654 10.2881 4.60883 12.8505 4.70261 12.6886C5.0874 12.0186 5.57708 11.9454 6.07205 11.8713C6.5499 11.7998 7.03267 11.7275 7.43073 11.1169C7.86718 10.357 7.60868 9.38562 6.8524 8.94828C6.09613 8.50852 5.12945 8.76827 4.69299 9.52818Z",
  fill: "#42526E"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var GO_DESIGN = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { GO_DESIGN as default };
